// 更新数据
export const SET_DATA = 'SET_DATA';
// 更新数量（长度）
export const SET_LENS = 'SET_LENS';
// 更新考试倒计时时间
export const SET_DURATION = 'SET_DURATION';
